module.exports = __webpack_public_path__ + "img/logo-house-medium.097df45e.svg";